window.dataLayer = window.dataLayer || [];

export default window.dataLayer;



// WEBPACK FOOTER //
// ../globals/dataLayer.js